import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '../shared/services/auth-guard.service';

import { UpdatesComponent } from './updates/updates.component';

export const updatesRoutes: Routes = [
  {
    path: 'updates',
    component: UpdatesComponent,
    canActivate: [AuthGuardService],
  },
];

export const UpdatesdRouting = RouterModule.forChild(updatesRoutes);
